import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import _ReactPlayer from "react-player";
import { ClipLoader } from "react-spinners";
import Button from "./Button.mjs";
import { u as useMediaPlayback, f as format } from "./date-time-C9VIKgtX.mjs";
const ReactPlayer = _ReactPlayer;
function AudioPlayer({
  filename,
  timestamp,
  getUrl,
  reactPlayerClassName,
  styles,
  audioWidth = "100%",
  playerWidth = "100%"
}) {
  const {
    isLoading,
    error,
    setError,
    secondsPlayed,
    setSecondsPlayed,
    durationInSeconds,
    setDurationInSeconds,
    playbackImgInfo,
    handlePlaybackClick,
    isPlaying,
    setIsPlaying,
    mediaPlayer,
    isMuted,
    formattedTimeInfo,
    mediaUrl,
    setHasEnded,
    reactPlayerId
  } = useMediaPlayback(getUrl);
  const renderAudioTitle = () => /* @__PURE__ */ jsx("h3", { className: "heading", children: filename ?? "Audio" });
  const renderProgressInfo = () => /* @__PURE__ */ jsxs("div", { className: "seek-bar-container", children: [
    /* @__PURE__ */ jsx("div", { className: "time-elapsed", children: formattedTimeInfo.elapsed }),
    /* @__PURE__ */ jsx("div", { className: "seek-bar", children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "elapsed-duration",
        style: {
          width: durationInSeconds ? `${100 * secondsPlayed / durationInSeconds}%` : 0
        }
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: "total-time", children: formattedTimeInfo.total })
  ] });
  const renderLoadingSpinner = () => /* @__PURE__ */ jsx("div", { "aria-label": "Loading Spinner", children: /* @__PURE__ */ jsx(ClipLoader, { color: "#458DC9", size: 16 }) });
  const renderTimestamp = () => /* @__PURE__ */ jsx("div", { className: "timestamp-container", children: format(new Date(timestamp), { date: false, time: true }) });
  const renderErrorMessage = () => /* @__PURE__ */ jsx("p", { className: "error", children: error });
  const renderPlayPauseReplayButton = () => /* @__PURE__ */ jsx(
    Button,
    {
      onClick: handlePlaybackClick,
      "aria-label": playbackImgInfo.alt,
      disabled: !!error || isLoading,
      children: /* @__PURE__ */ jsx(
        "img",
        {
          src: playbackImgInfo.src,
          alt: playbackImgInfo.alt,
          style: { marginLeft: !isPlaying ? 4 : 0 }
        }
      )
    }
  );
  const Player = /* @__PURE__ */ jsx(
    ReactPlayer,
    {
      ref: mediaPlayer,
      className: classNames(reactPlayerClassName ?? "", "react-player"),
      id: reactPlayerId,
      url: mediaUrl,
      playing: isPlaying,
      controls: false,
      muted: isMuted,
      progressInterval: 250,
      onProgress: (state) => setSecondsPlayed(state.playedSeconds),
      onPlay: () => {
        setHasEnded(false);
        setIsPlaying(true);
      },
      onDuration: (seconds) => setDurationInSeconds(seconds),
      onBuffer: () => {
      },
      onBufferEnd: () => {
      },
      onSeek: () => {
      },
      onEnded: () => setHasEnded(true),
      onError: () => {
        setError("A playback error occurred");
        setIsPlaying(false);
      },
      width: "100%",
      height: "auto",
      style: styles ?? {}
    }
  );
  const renderControls = () => /* @__PURE__ */ jsxs("div", { className: "controls", children: [
    /* @__PURE__ */ jsx("div", { className: "play-pause", children: isLoading ? renderLoadingSpinner() : renderPlayPauseReplayButton() }),
    error ? renderErrorMessage() : renderProgressInfo()
  ] });
  return /* @__PURE__ */ jsx("div", { className: "sa-audio-player-wrapper", style: { width: playerWidth }, children: /* @__PURE__ */ jsxs("div", { className: "sa-audio-player", style: { width: audioWidth }, children: [
    renderAudioTitle(),
    /* @__PURE__ */ jsxs(Fragment, { children: [
      !isLoading && mediaUrl && !error && Player,
      renderControls()
    ] }),
    renderTimestamp()
  ] }) });
}
export {
  AudioPlayer as default
};
